
(function() {
  var VARIANT_ID = window.KSM_VARIANT_ID;
  var selectedQty = 1;

  /* Gallery */
  var thumbs = document.querySelectorAll('#ksmGalleryThumbs img');
  var mainImg = document.getElementById('ksmGalleryMain');
  thumbs.forEach(function(t) {
    t.addEventListener('click', function() {
      thumbs.forEach(function(x) { x.classList.remove('active'); });
      t.classList.add('active');
      mainImg.src = t.getAttribute('data-src');
    });
  });

  /* Pricing */
    window.ksmSelectQty = function(qty) {
    selectedQty = qty;
    document.querySelectorAll('.ksm-price-option').forEach(function(o) {
      o.classList.toggle('active', parseInt(o.getAttribute('data-qty')) === qty);
    });
    var sel = document.querySelector('.ksm-price-option[data-qty="' + qty + '"]');
    if (sel) {
      var total = sel.getAttribute('data-total');
      var old = sel.getAttribute('data-old');
      var perKit = sel.getAttribute('data-per-kit') || total;
      var fmt = function(v){ return '€' + String(v).replace('.', ','); };
      document.getElementById('ksmBtnPrice').textContent = fmt(total);
      var stPrice = document.getElementById('ksmStickyPrice'); if (stPrice) stPrice.textContent = fmt(total);
      var stOld = document.getElementById('ksmStickyOld'); if (stOld) stOld.textContent = fmt(old);
      var stQty = document.getElementById('ksmStickyQty'); if (stQty) stQty.textContent = qty + ' Kit';
      var stPerKit = document.getElementById('ksmStickyPerKit'); if (stPerKit) stPerKit.textContent = fmt(perKit);
      // Hide redundant info when only 1 kit (per-kit == total)
      var totalLabel = document.getElementById('ksmStickyTotalLabel');
      if (totalLabel) {
        var isSingle = parseInt(qty, 10) === 1;
        totalLabel.style.display = isSingle ? 'none' : '';
        if (stPrice) stPrice.style.display = isSingle ? 'none' : '';
        // Also hide the "·" separator that sits before TOTALE
        var sep = totalLabel.previousElementSibling;
        if (sep && sep.tagName === 'SPAN') sep.style.display = isSingle ? 'none' : '';
      }
    }
  };
  // Sticky qty +/- selector
  window.ksmStickyQtyChange = function(delta) {
    var current = parseInt(document.querySelector('.ksm-price-option.active')?.getAttribute('data-qty') || '1', 10);
    var next = Math.max(1, Math.min(3, current + delta));
    if (next !== current) window.ksmSelectQty(next);
  };

  // Keep the sticky numeric badge in sync with the main qty
  (function(){
    var origSelect = window.ksmSelectQty;
    window.ksmSelectQty = function(qty){
      origSelect.apply(this, arguments);
      var stNum = document.getElementById('ksmStickyQtyNum');
      if (stNum) stNum.textContent = String(qty);
    };
  })();

  // Run once on init so the sticky reflects the default selection (1 kit)
  try { window.ksmSelectQty(1); } catch (e) {}

  /* Reset CTA to default label (so when user navigates back, it isn't stuck on "Aggiunto") */
  function ksmCtaDefaultHtml() {
    var btnPrice = '€69,90';
    try {
      var sel = document.querySelector('.ksm-price-option.active');
      if (sel) {
        var total = sel.getAttribute('data-total');
        if (total) btnPrice = '€' + total.replace('.', ',');
      }
    } catch (e) {}
    return '<span style="white-space:nowrap !important">Aggiungi al carrello</span> <span style="opacity:.5 !important">·</span> <span id="ksmBtnPrice" style="white-space:nowrap !important">' + btnPrice + '</span>';
  }
  function ksmResetCta() {
    var btn = document.getElementById('ksmAddBtn');
    if (!btn) return;
    btn.innerHTML = ksmCtaDefaultHtml();
    btn.disabled = false;
  }
  // Reset whenever page becomes visible again (back/forward navigation, tab switch)
  window.addEventListener('pageshow', ksmResetCta);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') ksmResetCta();
  });

  /* Add to cart — opens theme's sliding cart drawer (no redirect) */
  window.ksmAddToCart = function() {
    var btn = document.getElementById('ksmAddBtn');
    if (btn.disabled) return;
    btn.innerHTML = 'Aggiungo...';
    btn.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer');

    // Build sections list as comma-separated string (Shopify accepts both, but string is widest)
    var sectionsString = null;
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        sectionsString = cartDrawer.getSectionsToRender().map(function(s){ return s.section; }).join(',');
      } catch (e) {}
    }

    var formData = new FormData();
    formData.append('id', String(VARIANT_ID));
    formData.append('quantity', String(selectedQty));
    if (sectionsString) {
      formData.append('sections', sectionsString);
      formData.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(r) {
        // Only treat as REAL error if HTTP response itself failed
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(parsedState) {
        // Cart-add succeeded — never bail out from here on, just be defensive
        if (parsedState && parsedState.status && parsedState.status >= 400) {
          // Shopify returned a soft error (e.g. out of stock) — show it inline
          ksmResetCta();
          alert(parsedState.description || 'Impossibile aggiungere al carrello.');
          return;
        }

        btn.innerHTML = '✓ Aggiunto';

        // Each side-effect below is wrapped — none should ever surface to the user
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ksm-pdp', productVariantId: VARIANT_ID, cartData: parsedState });
          }
        } catch (e) { console.warn('publish failed', e); }

        try {
          var opened = false;
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState && parsedState.sections) {
            try { cartDrawer.renderContents(parsedState); opened = true; }
            catch (e) { console.warn('renderContents failed', e); }
          }
          if (!opened && cartDrawer) {
            try { if (typeof cartDrawer.reload === 'function') cartDrawer.reload(); } catch (e) {}
            setTimeout(function() {
              try {
                if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
                else document.dispatchEvent(new CustomEvent('cart:open'));
              } catch (e) { console.warn('open failed', e); }
            }, 80);
          } else if (!cartDrawer) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        } catch (e) { console.warn('drawer open chain failed', e); }

        setTimeout(ksmResetCta, 1500);
      })
      .catch(function(err) {
        // Reached only if /cart/add.js never returned a 2xx response
        console.error('ksmAddToCart fetch error', err);
        ksmResetCta();
        alert('Errore di rete. Riprova.');
      });
  };

  /* Sticky */
  var stickyAtc = document.getElementById('ksmStickyAtc');
  var heroPdp = document.querySelector('.ksm-hero-pdp');
  var footerCta = document.querySelector('.ksm-footer-cta');
  function checkSticky() {
    if (!heroPdp || !stickyAtc) return;
    var heroBottom = heroPdp.getBoundingClientRect().bottom;
    var footerTop = footerCta ? footerCta.getBoundingClientRect().top : 99999;
    stickyAtc.classList.toggle('visible', heroBottom < 0 && footerTop > window.innerHeight - 80);
  }
  window.addEventListener('scroll', checkSticky, { passive: true });
  window.addEventListener('resize', checkSticky);
  setTimeout(checkSticky, 100);

  /* Scroll fade-in animations */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.ksm-fade').forEach(function(el) { io.observe(el); });
  } else {
    document.querySelectorAll('.ksm-fade').forEach(function(el) { el.classList.add('in'); });
  }

  /* QUIZ */
  var quizScore = 0, quizStep = 1, quizTotal = 4;
  window.ksmQuizAns = function(btn) {
    quizScore += parseInt(btn.getAttribute('data-score')) || 0;
    var current = document.querySelector('.ksm-quiz-step[data-step="' + quizStep + '"]');
    if (current) current.classList.remove('active');
    quizStep++;
    if (quizStep <= quizTotal) {
      var next = document.querySelector('.ksm-quiz-step[data-step="' + quizStep + '"]');
      if (next) next.classList.add('active');
      var fill = document.getElementById('ksmQuizFill');
      if (fill) fill.style.width = (quizStep * 25) + '%';
    } else {
      var resultStep = document.querySelector('.ksm-quiz-step[data-step="result"]');
      if (resultStep) resultStep.classList.add('active');
      var fill = document.getElementById('ksmQuizFill');
      if (fill) fill.style.width = '100%';
      ksmQuizShowResult(quizScore);
    }
  };
  function ksmQuizShowResult(score) {
    var emoji = document.getElementById('ksmQuizEmoji');
    var title = document.getElementById('ksmQuizResultTitle');
    var text = document.getElementById('ksmQuizResultText');
    if (score >= 6) {
      emoji.innerHTML = '&#127919;';
      title.textContent = 'Sì, è il momento giusto.';
      text.innerHTML = 'I tuoi segnali (fame, sonno, ritenzione, ritmo intenso) puntano tutti nella stessa direzione: <strong>asse stress&ndash;metabolismo sotto pressione.</strong> Il kit è disegnato per questo profilo. Inizia un ciclo di 8 settimane.';
    } else if (score >= 3) {
      emoji.innerHTML = '&#128064;';
      title.textContent = 'Vale la pena provare.';
      text.innerHTML = 'Alcuni segnali ci sono. Un ciclo di 8 settimane è la finestra ideale per <strong>capire se il tuo corpo risponde</strong>. Senza pretese miracolose, solo claim approvati EFSA e Ministero della Salute.';
    } else {
      emoji.innerHTML = '&#128170;';
      title.textContent = 'Sembri abbastanza in equilibrio.';
      text.innerHTML = 'I segnali sono pochi. Se vuoi un supporto preventivo nei periodi più stressanti dell\'anno, il kit funziona anche come <strong>protocollo a fasi</strong>. Altrimenti, conserva la pagina per quando ne avrai bisogno.';
    }
  }

  /* CAROUSELS */
  window.ksmCarouselScroll = function(trackId, dir) {
    var track = document.getElementById(trackId);
    if (!track) return;
    var card = track.querySelector('.ksm-mech-card, .ksm-efsa-card, .ksm-bot-card');
    var step = card ? card.offsetWidth + parseInt(getComputedStyle(track).gap || 18) : 320;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  function setupCarousel(trackId, dotsId) {
    var track = document.getElementById(trackId);
    var dotsEl = document.getElementById(dotsId);
    if (!track || !dotsEl) return;
    var cards = track.children.length;
    dotsEl.innerHTML = '';
    for (var i = 0; i < cards; i++) {
      (function(idx) {
        var d = document.createElement('button');
        d.className = 'ksm-carousel-dot' + (idx === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Card ' + (idx + 1));
        d.onclick = function() {
          var card = track.children[idx];
          if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        };
        dotsEl.appendChild(d);
      })(i);
    }
    function updateDots() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var bestIdx = 0, bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var r = track.children[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var dist = Math.abs(c - center);
        if (dist < bestDist) { bestDist = dist; bestIdx = i; }
      }
      Array.from(dotsEl.children).forEach(function(d, i) {
        d.classList.toggle('active', i === bestIdx);
      });
    }
    track.addEventListener('scroll', updateDots, { passive: true });
    setTimeout(updateDots, 50);

    /* drag to scroll on desktop */
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function(e) {
      isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function() { isDown = false; });
    track.addEventListener('mouseup', function() { isDown = false; });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX);
    });
  }
  setupCarousel('ksmMechTrack', 'ksmMechDots');
  setupCarousel('ksmEfsaTrack', 'ksmEfsaDots');

  /* CORTISOL STAGGER ANIMATION */
  if ('IntersectionObserver' in window) {
    var ioCort = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          ioCort.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.ksm-cortisol-step').forEach(function(el) { ioCort.observe(el); });
  }

  /* QUALITY STAGGER */
  if ('IntersectionObserver' in window) {
    var ioQ = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          ioQ.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.ksm-quality-card').forEach(function(el) { ioQ.observe(el); });
  }

    /* REVIEWS */
  var FALLBACK = [
    { s: 5, t: "Da tre settimane la sera mi addormento senza il solito chiacchiericcio in testa. Il misurino di MAG-5+ va davvero giù come acqua fresca.", n: "Giulia M.", i: "GM", tags: ["stress", "sonno"] },
    { s: 5, t: "La compressa al mattino è entrata in colazione senza pensarci. Dopo due mesi sento la giornata più gestibile e meno tensione nelle spalle.", n: "Marta P.", i: "MP", tags: ["stress", "energia"] },
    { s: 4, t: "Compresse piccole, facili da deglutire. Sui sintomi di stress mi sta funzionando bene. Il gusto agrumato del magnesio è piacevole.", n: "Sara L.", i: "SL", tags: ["stress"] },
    { s: 5, t: "Compro spesso integratori. Questo è uno dei pochi dove vedo davvero il dossier scientifico: KSM-66 dosata e 5 forme di magnesio.", n: "Federica T.", i: "FT", tags: ["energia"] },
    { s: 5, t: "Mente sempre attiva la sera, mai. Dalla seconda settimana sono riuscita ad addormentarmi prima e a riposare meglio.", n: "Anna R.", i: "AR", tags: ["sonno", "stress"] },
    { s: 5, t: "Lo prendo da 4 settimane. Le mattine sono diverse, mi sveglio meno appesantita e con più voglia. Spedizione veloce.", n: "Chiara V.", i: "CV", tags: ["sonno", "energia"] },
    { s: 4, t: "Buona idea il kit, comodo avere tutto incluso invece di due barattoli sparsi. La compressa di Ashwa B+ non ha sapore.", n: "Elena B.", i: "EB", tags: ["stanchezza"] },
    { s: 5, t: "Sono in menopausa precoce e lo stress si sentiva tutto. Da quando uso il kit gestisco molto meglio i picchi di tensione serali.", n: "Patrizia D.", i: "PD", tags: ["stress", "stanchezza"] },
    { s: 5, t: "Mi è piaciuto il fatto che spiegano benissimo cosa fanno gli ingredienti, con solo claim approvati EFSA. Massima trasparenza.", n: "Lucia G.", i: "LG", tags: ["energia"] },
    { s: 5, t: "Ho confrontato dosaggi con altri brand: qui sono dosaggi seri. Migliore qualità trovata in Italia in questa fascia di prezzo.", n: "Roberta F.", i: "RF", tags: ["energia"] },
    { s: 4, t: "Compressa al mattino + misurino la sera, una routine semplice. La cosa che ho notato di più è il sonno più profondo.", n: "Daniela M.", i: "DM", tags: ["sonno"] },
    { s: 5, t: "Stanchezza pomeridiana era il mio chiodo fisso. Dalla terza settimana ho ricominciato ad arrivare alla sera con energia.", n: "Cristina S.", i: "CS", tags: ["stanchezza", "energia"] },
    { s: 5, t: "Servizio clienti su WhatsApp velocissimo. Mi hanno aiutato a scegliere il protocollo giusto e mi sono trovata bene.", n: "Alessandro F.", i: "AF", tags: ["stress"] },
    { s: 5, t: "Mi addormento prima e mi sveglio meno volte di notte. Il magnesio bisglicinato si sente, niente effetto lassativo.", n: "Valentina B.", i: "VB", tags: ["sonno"] },
    { s: 4, t: "Ottimo per chi vive periodi intensi. Ashwagandha KSM-66 brevettata, ne ho letto i trial: dosaggio in linea con la letteratura.", n: "Marco T.", i: "MT", tags: ["stress"] },
    { s: 5, t: "Lavoro davanti al PC tutto il giorno, stanchezza mentale a picco. Dopo un mese di kit la concentrazione pomeridiana è tornata.", n: "Silvia R.", i: "SR", tags: ["stanchezza", "energia"] },
    { s: 5, t: "Avevo provato altri magnesio ma davano mal di stomaco. Il MAG-5+ no, lo sciogli in acqua e via. Eccellente formulazione.", n: "Francesca L.", i: "FL", tags: ["energia"] },
    { s: 5, t: "Ho dormito profondamente come non capitava da mesi. È diventato il mio rituale serale prima di letto.", n: "Beatrice C.", i: "BC", tags: ["sonno", "stress"] },
    { s: 4, t: "Dopo 60 giorni mi sento più centrata. La tensione muscolare nel collo è migliorata sensibilmente, niente più contratture serali.", n: "Letizia A.", i: "LA", tags: ["stanchezza", "stress"] },
    { s: 5, t: "Lo consiglio a chi ha periodi di iperattività mentale. La sensazione di pace serale è quello che cercavo. Riacquistato.", n: "Stefania P.", i: "SP", tags: ["stress", "sonno"] }
  ];
  window.KSM_REVIEWS = FALLBACK;
  var THEME_LABELS = { sonno: 'Sonno', energia: 'Energia', stanchezza: 'Stanchezza', stress: 'Stress' };
  var PER_PAGE = 6, currentPage = 1, filtered = [];
  function starsHtml(n) { var s = ''; for (var i = 0; i < 5; i++) s += i < n ? '★' : '☆'; return s; }
  function renderCard(rev) {
    var tagsHtml = '';
    if (rev.tags && rev.tags.length) {
      tagsHtml = '<div class="ksm-review-tags">';
      rev.tags.forEach(function(t) { tagsHtml += '<span class="ksm-review-tag">' + (THEME_LABELS[t] || t) + '</span>'; });
      tagsHtml += '</div>';
    }
    var authorHtml = '<div class="ksm-review-author"><div class="ksm-review-avatar">' + (rev.i || '?') + '</div><div><div class="ksm-review-name">' + (rev.n || 'Anonimo') + '</div><div class="ksm-review-verified">✓ Acquisto verificato</div></div></div>';
    return '<div class="ksm-review-card"><div class="ksm-review-stars">' + starsHtml(rev.s) + '</div><div class="ksm-review-text">' + rev.t + '</div>' + tagsHtml + authorHtml + '</div>';
  }
  function applyFilter(filter) {
    currentPage = 1;
    var reviews = window.KSM_REVIEWS || [];
    filtered = filter === 'all' ? reviews.slice() : reviews.filter(function(r) { return r.tags && r.tags.indexOf(filter) !== -1; });
    renderPage();
  }
  function renderPage() {
    var grid = document.getElementById('ksmRevGrid');
    var moreBtn = document.getElementById('ksmRevMore');
    var empty = document.getElementById('ksmRevEmpty');
    if (!grid) return;
    var end = currentPage * PER_PAGE;
    var visible = filtered.slice(0, end);
    grid.innerHTML = '';
    visible.forEach(function(rev) { grid.innerHTML += renderCard(rev); });
    if (filtered.length === 0) { empty.style.display = 'block'; moreBtn.style.display = 'none'; }
    else { empty.style.display = 'none'; moreBtn.style.display = end < filtered.length ? 'block' : 'none'; }
  }
  window.ksmRevLoadMore = function() { currentPage++; renderPage(); };
  document.querySelectorAll('.ksm-rev-filter').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.ksm-rev-filter').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      applyFilter(btn.getAttribute('data-filter'));
    });
  });
  applyFilter('all');
})();

/* Value block + guarantee + perks animation observer */
(function() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('ksm-vis');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('.ksm-value-block, .ksm-guarantee, .ksm-perks-row').forEach(function(el) { io.observe(el); });
})();
